import React from 'react';
import { useUnifiedAuth } from '@/contexts/auth/UnifiedAuthProvider';
import { getTimeSinceLastRefresh } from '@/lib/auth-query-coordinator';
import { ENVIRONMENT } from '@/lib/environment';

const AuthStatusBanner: React.FC = () => {
  const { authSettled, hardExpired } = useUnifiedAuth();
  const [sinceMs, setSinceMs] = React.useState<number>(getTimeSinceLastRefresh());
  const [lastReason, setLastReason] = React.useState<string | undefined>();

  React.useEffect(() => {
    const t = setInterval(() => setSinceMs(getTimeSinceLastRefresh()), 1000);
    return () => clearInterval(t);
  }, []);

  React.useEffect(() => {
    if (hardExpired) {
      setLastReason('session_expired');
    } else if (authSettled) {
      setLastReason(undefined);
    }
  }, [hardExpired, authSettled]);

  if (!ENVIRONMENT.isAuthDebug()) return null;

  return (
    <div style={{ position: 'fixed', bottom: 8, right: 8, zIndex: 9999 }}>
      <div className="px-3 py-2 text-xs rounded-md border bg-white shadow-sm">
        <div><strong>Auth</strong>: settled={String(authSettled)} hardExpired={String(hardExpired)}</div>
        <div>lastRefreshMs={sinceMs}</div>
        {lastReason && <div>lastReason={lastReason}</div>}
      </div>
    </div>
  );
};

export default AuthStatusBanner;


